import React from 'react';
import './SelectListOptionHeader.scss';
function SelectListOptionHeader(_a) {
    var _b = _a.ariaLevel, ariaLevel = _b === void 0 ? 1 : _b, children = _a.children;
    return (React.createElement("div", { className: "elmo-select-list__option-header", role: "heading", "aria-level": ariaLevel }, children));
}
export default SelectListOptionHeader;
